import { render, staticRenderFns } from "./UsersHead.vue?vue&type=template&id=e5778542"
import script from "./UsersHead.vue?vue&type=script&lang=js"
export * from "./UsersHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports